// extracted by mini-css-extract-plugin
module.exports = {"vip":"vip-1uaXu"};